define('adminApiStatsListView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'marionette',
  'moment',
  'template!adminApiStatsListTpl',
  'adminApiStatsBlockView',
  'entities/admin/api_stats'
], function (
  Module,
  App,
  _,
  $,
  Marionette,
  moment,
  tpl,
  BlockView
) {
  'use strict';

  // Breakdown tabs; a row click narrows the filter and moves to the next tab.
  var API_TABS = {
    accounts: { groupBy: 'ACCOUNT', next: 'users' },
    users: { groupBy: 'USER', next: 'endpoints' },
    endpoints: { groupBy: 'ENDPOINT', next: 'users' },
    clients: { groupBy: 'CLIENT', next: 'users' },
    hosts: { groupBy: 'HOST', next: 'origins' },
    origins: { groupBy: 'ORIGIN', next: 'users' },
    apps: { groupBy: 'APP', next: 'endpoints' }
  };
  var NOTIFICATION_TABS = {
    accounts: { groupBy: 'ACCOUNT', next: 'sources' },
    types: { groupBy: 'TYPE', next: 'sources' },
    sources: { groupBy: 'SOURCE', next: 'triggers' },
    triggers: { groupBy: 'TRIGGER', next: 'sources' }
  };
  var FILTER_KEYS = {
    api: ['accountId', 'userpidId', 'httpMethod', 'endpoint', 'clientFamily', 'host', 'origin', 'app'],
    notifications: ['accountUid', 'notificationType', 'source', 'triggeredBy']
  };
  var SORT_FIELD = {
    CALLS: 'calls', ERRORS: 'errors', AVG_MS: 'avgMs', MAX_MS: 'maxMs', TOTAL_MS: 'totalMs', BYTES: 'bytes'
  };
  var HOURLY_MAX_DAYS = 2;

  Module.exports = Marionette.ItemView.extend({
    template: tpl,
    className: 'admin-api-stats-view',

    ui: {
      from: '.js-from',
      to: '.js-to',
      sort: '.js-sort',
      tooltip: '.js-tooltip',
      chart: '.js-chart'
    },

    events: {
      'click .js-apply': 'onApply',
      'click .js-preset': 'onPreset',
      'click .js-mode': 'onMode',
      'click .js-tab': 'onTab',
      'change .js-sort': 'onSort',
      'click .js-row': 'onRowClick',
      'click .js-clear-filter': 'onClearFilter',
      'click .js-refresh': 'refresh',
      'mouseenter .js-bar': 'onBarEnter',
      'mouseleave .js-chart': 'onChartLeave'
    },

    initialize: function () {
      this.access = null;
      this.blockView = null;
      this.loading = false;
      this.error = false;
      this.mode = 'api';
      // Last statistics mode (api | notifications), to come back to it from 'block' as it was.
      this.statsMode = 'api';
      this.tab = 'accounts';
      this.sort = 'CALLS';
      this.filter = {};
      this.summary = null;
      this.rows = [];
      this.bars = [];
      this.applyPreset('7d', { silent: true });
    },

    serializeData: function () {
      var access = this.access || {};
      return {
        checking: this.access === null,
        canView: access.canView === true,
        allAccounts: access.allAccounts === true,
        canBlock: access.canBlock === true,
        loading: this.loading,
        error: this.error,
        preset: this.preset,
        mode: this.mode,
        fromValue: this.from.format('YYYY-MM-DD'),
        toValue: this.to.format('YYYY-MM-DD'),
        tab: this.tab,
        sort: this.sort,
        chips: this.filterChips(),
        kpis: this.computeKpis(),
        rows: this.rows,
        bars: this.bars,
        hourly: this.isHourly(),
        axis: this.axisLabels()
      };
    },

    onShow: function () {
      var that = this;
      App.request('apiStats:access').done(function (access) {
        that.access = access;
        if (!access.canView) {
          that.render();
          return;
        }
        that.tab = that.defaultTab();
        that.refresh();
      });
    },

    // ---------- mode -----------------------------------------------------

    tabs: function () {
      return this.mode === 'notifications' ? NOTIFICATION_TABS : API_TABS;
    },

    defaultTab: function () {
      var allAccounts = this.access && this.access.allAccounts;
      if (this.mode === 'notifications') {
        return allAccounts ? 'accounts' : 'sources';
      }
      return allAccounts ? 'accounts' : 'users';
    },

    onMode: function (e) {
      var mode = $(e.currentTarget).data('mode');
      if (mode === this.mode) { return; }
      var fromBlock = this.mode === 'block';
      this.mode = mode;
      if (mode === 'block') {
        // Own data (BlockView); the statistics filters are kept for the way back.
        this.render();
        return;
      }
      if (fromBlock && this.statsMode === mode) {
        this.render();
        return;
      }
      this.statsMode = mode;
      this.filter = {};
      this.tab = this.defaultTab();
      if (this.sort === 'BYTES' && mode !== 'notifications') { this.sort = 'CALLS'; }
      this.refresh();
    },

    request: function (name, params) {
      return App.request((this.mode === 'notifications' ? 'apiStats:notifications:' : 'apiStats:') + name, params);
    },

    // ---------- blocking --------------------------------------------------

    // The blocking view keeps its state across modes: detach it (events kept) before
    // this view replaces its DOM, put it back after.
    onBeforeRender: function () {
      if (this.blockView) {
        this.blockView.$el.detach();
      }
    },

    onRender: function () {
      if (this.mode !== 'block') {
        return;
      }
      if (!this.blockView) {
        this.blockView = new BlockView();
        this.blockView.render();
        this.$('.js-block-container').append(this.blockView.$el);
        this.blockView.triggerMethod('show');
      } else {
        this.$('.js-block-container').append(this.blockView.$el);
      }
    },

    onDestroy: function () {
      if (this.blockView) {
        this.blockView.destroy();
      }
    },

    // ---------- period ---------------------------------------------------

    applyPreset: function (preset, opts) {
      var now = moment();
      this.to = now.clone().endOf('day');
      switch (preset) {
        case 'today':
          this.from = now.clone().startOf('day');
          break;
        case '24h':
          this.from = now.clone().subtract(24, 'hours').startOf('hour');
          this.to = now.clone().endOf('hour');
          break;
        case '30d':
          this.from = now.clone().subtract(29, 'days').startOf('day');
          break;
        case '90d':
          this.from = now.clone().subtract(89, 'days').startOf('day');
          break;
        default:
          preset = '7d';
          this.from = now.clone().subtract(6, 'days').startOf('day');
          break;
      }
      this.preset = preset;
      if (!opts || !opts.silent) {
        this.refresh();
      }
    },

    onPreset: function (e) {
      this.applyPreset($(e.currentTarget).data('preset'));
    },

    onApply: function () {
      var fromVal = this.ui.from.val();
      var toVal = this.ui.to.val();
      if (fromVal) { this.from = moment(fromVal, 'YYYY-MM-DD').startOf('day'); }
      if (toVal) { this.to = moment(toVal, 'YYYY-MM-DD').endOf('day'); }
      if (this.to.isBefore(this.from)) {
        this.to = this.from.clone().endOf('day');
      }
      this.preset = 'custom';
      this.refresh();
    },

    isHourly: function () {
      return this.to.diff(this.from, 'days', true) <= HOURLY_MAX_DAYS;
    },

    // ---------- filters --------------------------------------------------

    params: function () {
      return _.extend({
        from: this.from.valueOf(),
        to: this.to.valueOf() + 1
      }, _.pick(this.filter, FILTER_KEYS[this.mode]));
    },

    filterChips: function () {
      var chips = [];
      if (this.mode === 'notifications') {
        if (this.filter.accountUid !== undefined) {
          chips.push({ key: 'accountUid', icon: 'fa-building', label: this.filter.accountLabel });
        }
        if (this.filter.notificationType !== undefined) {
          chips.push({ key: 'notificationType', icon: 'fa-tag', label: this.filter.notificationType });
        }
        if (this.filter.source !== undefined) {
          chips.push({ key: 'source', icon: 'fa-code', label: this.filter.source });
        }
        if (this.filter.triggeredBy !== undefined) {
          chips.push({ key: 'triggeredBy', icon: 'fa-bolt', label: this.filter.triggeredBy });
        }
        return chips;
      }
      if (this.filter.accountId !== undefined) {
        chips.push({ key: 'account', icon: 'fa-building', label: this.filter.accountLabel });
      }
      if (this.filter.userpidId !== undefined) {
        chips.push({ key: 'user', icon: 'fa-user', label: this.filter.userLabel });
      }
      if (this.filter.endpoint !== undefined) {
        chips.push({ key: 'endpoint', icon: 'fa-plug', label: this.filter.httpMethod + ' ' + this.filter.endpoint });
      }
      if (this.filter.clientFamily !== undefined) {
        chips.push({ key: 'client', icon: 'fa-desktop', label: this.filter.clientFamily });
      }
      if (this.filter.host !== undefined) {
        chips.push({ key: 'host', icon: 'fa-server', label: this.hostLabel(this.filter.host) });
      }
      if (this.filter.origin !== undefined) {
        chips.push({ key: 'origin', icon: 'fa-globe', label: this.originLabel(this.filter.origin) });
      }
      if (this.filter.app !== undefined) {
        chips.push({ key: 'app', icon: 'fa-cubes', label: this.filter.app });
      }
      return chips;
    },

    onClearFilter: function (e) {
      var key = $(e.currentTarget).data('key');
      if (key === 'accountUid') {
        this.filter = _.omit(this.filter, 'accountUid', 'accountLabel');
      } else if (key === 'notificationType' || key === 'source' || key === 'triggeredBy') {
        this.filter = _.omit(this.filter, key);
      } else if (key === 'account') {
        this.filter = _.omit(this.filter, 'accountId', 'accountLabel');
      } else if (key === 'user') {
        this.filter = _.omit(this.filter, 'userpidId', 'userLabel');
      } else if (key === 'client') {
        this.filter = _.omit(this.filter, 'clientFamily');
      } else if (key === 'host' || key === 'origin' || key === 'app') {
        this.filter = _.omit(this.filter, key);
      } else {
        this.filter = _.omit(this.filter, 'httpMethod', 'endpoint');
      }
      this.refresh();
    },

    onTab: function (e) {
      this.tab = $(e.currentTarget).data('tab');
      this.refreshBreakdown();
    },

    onSort: function () {
      this.sort = this.ui.sort.val();
      this.refreshBreakdown();
    },

    onRowClick: function (e) {
      var row = this.rows[$(e.currentTarget).data('index')];
      if (!row) { return; }
      if (this.mode === 'notifications') {
        if (this.tab === 'accounts') {
          this.filter.accountUid = row.accountUid;
          this.filter.accountLabel = row.title;
        } else if (this.tab === 'types') {
          this.filter.notificationType = row.notificationType;
        } else if (this.tab === 'sources') {
          this.filter.source = row.source;
        } else {
          this.filter.triggeredBy = row.triggeredBy;
        }
        this.tab = NOTIFICATION_TABS[this.tab].next;
        this.refresh();
        return;
      }
      if (this.tab === 'accounts') {
        this.filter.accountId = row.accountId;
        this.filter.accountLabel = row.title;
      } else if (this.tab === 'users') {
        this.filter.userpidId = row.userpidId;
        this.filter.userLabel = row.title;
      } else if (this.tab === 'clients') {
        this.filter.clientFamily = row.clientFamily;
      } else if (this.tab === 'hosts') {
        this.filter.host = row.host;
      } else if (this.tab === 'origins') {
        this.filter.origin = row.origin;
      } else if (this.tab === 'apps') {
        this.filter.app = row.app;
      } else {
        this.filter.httpMethod = row.httpMethod;
        this.filter.endpoint = row.endpoint;
      }
      this.tab = API_TABS[this.tab].next;
      this.refresh();
    },

    // ---------- data -----------------------------------------------------

    refresh: function () {
      var that = this;
      var params = this.params();
      this.loading = true;
      this.error = false;
      this.render();
      $.when(
        this.request('summary', params),
        this.request('timeline', params),
        this.request('breakdown', this.breakdownParams())
      ).done(function (summary, timeline, rows) {
        that.summary = summary;
        that.bars = that.computeBars(timeline || []);
        that.rows = that.computeRows(rows || []);
      }).fail(function () {
        that.error = true;
      }).always(function () {
        that.loading = false;
        that.render();
      });
    },

    refreshBreakdown: function () {
      var that = this;
      this.loading = true;
      this.render();
      this.request('breakdown', this.breakdownParams()).done(function (rows) {
        that.rows = that.computeRows(rows || []);
      }).fail(function () {
        that.error = true;
      }).always(function () {
        that.loading = false;
        that.render();
      });
    },

    breakdownParams: function () {
      return _.extend(this.params(), { groupBy: this.tabs()[this.tab].groupBy, sort: this.sort, limit: 200 });
    },

    computeKpis: function () {
      var s = this.summary || {};
      var calls = s.calls || 0;
      var errors = this.errorsOf(s);
      return {
        calls: this.formatNumber(calls),
        errors: this.formatNumber(errors),
        errorRate: calls > 0 ? (errors * 100 / calls).toFixed(errors * 100 / calls < 10 ? 1 : 0) + '%' : '0%',
        serverErrors: this.formatNumber(s.serverErrors || 0),
        avgMs: this.formatMs(s.avgMs || 0),
        maxMs: this.formatMs(s.maxMs || 0),
        accounts: this.formatNumber(s.accounts || 0),
        users: this.formatNumber(s.users || 0),
        endpoints: this.formatNumber(s.endpoints || 0),
        clients: this.formatNumber(s.clients || 0),
        types: this.formatNumber(s.types || 0),
        sources: this.formatNumber(s.sources || 0),
        triggers: this.formatNumber(s.triggers || 0),
        bytes: this.formatBytes(s.bytes || 0)
      };
    },

    // API rows split 4xx / 5xx; notification rows carry a single failure count.
    errorsOf: function (r) {
      if (r.errors !== undefined) { return r.errors || 0; }
      return (r.clientErrors || 0) + (r.serverErrors || 0);
    },

    computeRows: function (rows) {
      var that = this;
      var field = SORT_FIELD[this.sort];
      var metric = function (r) {
        if (field === 'errors') { return that.errorsOf(r); }
        if (field === 'totalMs') { return (r.avgMs || 0) * (r.calls || 0); }
        return r[field] || 0;
      };
      var max = _.max(_.map(rows, metric)) || 1;
      return _.map(rows, function (r) {
        var errors = that.errorsOf(r);
        var notification = that.mode === 'notifications';
        return _.extend({}, r, {
          title: that.rowTitle(r),
          subtitle: that.rowSubtitle(r),
          barPct: Math.max(1, Math.round(metric(r) * 100 / max)),
          callsLabel: that.formatNumber(r.calls || 0),
          errorsLabel: that.formatNumber(errors),
          hasServerErrors: notification ? errors > 0 : (r.serverErrors || 0) > 0,
          errorTitle: notification ? errors + ' ' + _.i18n('admin.apiStats.failedSends', null, 'failed sends') :
            (r.clientErrors || 0) + ' 4xx · ' + (r.serverErrors || 0) + ' 5xx',
          bytesLabel: that.formatBytes(r.bytes || 0),
          sourcesLabel: r.sources !== undefined ? that.formatNumber(r.sources) : '',
          triggersLabel: r.triggers !== undefined ? that.formatNumber(r.triggers) : '',
          avgLabel: that.formatMs(r.avgMs || 0),
          maxLabel: that.formatMs(r.maxMs || 0),
          usersLabel: r.users !== undefined ? that.formatNumber(r.users) : '',
          accountsLabel: r.accounts !== undefined ? that.formatNumber(r.accounts) : '',
          endpointsLabel: r.endpoints !== undefined ? that.formatNumber(r.endpoints) : '',
          clientsLabel: r.clients !== undefined ? that.formatNumber(r.clients) : ''
        });
      });
    },

    rowTitle: function (r) {
      if (this.mode === 'notifications') {
        if (this.tab === 'accounts') {
          return r.accountCode || r.accountUid;
        }
        if (this.tab === 'types') { return r.notificationType; }
        if (this.tab === 'sources') { return r.source; }
        return r.triggeredBy;
      }
      if (this.tab === 'accounts') {
        return r.accountId === -1 ? _.i18n('admin.apiStats.anonymous', null, 'Anonymous') :
          (r.accountCode || ('#' + r.accountId));
      }
      if (this.tab === 'users') {
        if (r.userpidId === -1) { return _.i18n('admin.apiStats.noUser', null, 'No user (anonymous / API key)'); }
        var name = ((r.firstName || '') + ' ' + (r.lastName || '')).trim();
        return name || r.logonId || ('#' + r.userpidId);
      }
      if (this.tab === 'clients') {
        return r.clientFamily === '(none)' ?
          _.i18n('admin.apiStats.noUserAgent', null, 'No User-Agent') : r.clientFamily;
      }
      if (this.tab === 'hosts') { return this.hostLabel(r.host); }
      if (this.tab === 'origins') { return this.originLabel(r.origin); }
      if (this.tab === 'apps') { return r.app; }
      return r.endpoint;
    },

    // Placeholders written by the backend (ApiRequestHosts / ApiCallStatsCollector).
    hostLabel: function (host) {
      switch (host) {
        case '(none)': return _.i18n('admin.apiStats.noHost', null, 'No Host header');
        case '(ip)': return _.i18n('admin.apiStats.ipHost', null, 'IP address (direct / scanners)');
        case '(invalid)': return _.i18n('admin.apiStats.invalidHost', null, 'Invalid value');
        case '(other)': return _.i18n('admin.apiStats.otherHost', null, 'Other (hourly cap reached)');
        default: return host;
      }
    },

    originLabel: function (origin) {
      return origin === '(none)' ?
        _.i18n('admin.apiStats.noOrigin', null, 'No origin (server-to-server)') : this.hostLabel(origin);
    },

    rowSubtitle: function (r) {
      if (this.mode === 'notifications') {
        return this.tab === 'accounts' ? (r.accountName || '') : '';
      }
      if (this.tab === 'accounts') { return r.accountName || ''; }
      if (this.tab === 'users') {
        return _.compact([r.logonId, r.accountCode]).join(' · ');
      }
      return '';
    },

    // One bar per hour (short ranges) or per local day, gaps filled with zero.
    computeBars: function (points) {
      var hourly = this.isHourly();
      var unit = hourly ? 'hour' : 'day';
      var buckets = {};
      var that = this;
      _.each(points, function (p) {
        var key = moment(p.bucketStart).startOf(unit).valueOf();
        var b = buckets[key] || (buckets[key] = { calls: 0, errors: 0, totalMs: 0 });
        b.calls += p.calls || 0;
        b.errors += that.errorsOf(p);
        b.totalMs += (p.avgMs || 0) * (p.calls || 0);
      });
      var bars = [];
      var cursor = this.from.clone().startOf(unit);
      var end = moment.min(this.to, moment());
      while (!cursor.isAfter(end) && bars.length < 400) {
        var k = cursor.valueOf();
        var b = buckets[k] || { calls: 0, errors: 0, totalMs: 0 };
        bars.push({
          start: k,
          label: hourly ? cursor.format('ddd D MMM HH:00') : cursor.format('ddd D MMM YYYY'),
          calls: b.calls,
          errors: b.errors,
          avgMs: b.calls > 0 ? Math.round(b.totalMs / b.calls) : 0
        });
        cursor.add(1, unit);
      }
      var max = _.max(_.pluck(bars, 'calls')) || 1;
      _.each(bars, function (bar) {
        bar.okPct = (bar.calls - bar.errors) * 100 / max;
        bar.errPct = bar.errors * 100 / max;
      });
      this.chartMax = max;
      return bars;
    },

    axisLabels: function () {
      var max = this.chartMax || 0;
      if (!this.bars.length) { return null; }
      var first = this.bars[0];
      var last = this.bars[this.bars.length - 1];
      var fmt = this.isHourly() ? 'D MMM HH:00' : 'D MMM';
      return {
        max: this.formatNumber(max),
        half: this.formatNumber(Math.round(max / 2)),
        first: moment(first.start).format(fmt),
        last: moment(last.start).format(fmt)
      };
    },

    // ---------- chart hover ----------------------------------------------

    onBarEnter: function (e) {
      var $bar = $(e.currentTarget);
      var bar = this.bars[$bar.data('index')];
      if (!bar) { return; }
      this.$('.js-bar').removeClass('hover');
      $bar.addClass('hover');
      this.ui.tooltip.html(
        '<div class="tt-title">' + _.escape(bar.label) + '</div>' +
        '<div><span class="tt-key">' + _.escape(_.i18n('admin.apiStats.calls', null, 'Calls')) + '</span>' +
          this.formatNumber(bar.calls) + '</div>' +
        '<div><span class="tt-key">' + _.escape(_.i18n('admin.apiStats.errors', null, 'Errors')) + '</span>' +
          this.formatNumber(bar.errors) + '</div>' +
        '<div><span class="tt-key">' + _.escape(_.i18n('admin.apiStats.avg', null, 'Avg')) + '</span>' +
          this.formatMs(bar.avgMs) + '</div>'
      );
      var chartWidth = this.ui.chart.width();
      var left = $bar.position().left + $bar.outerWidth() / 2;
      var ttWidth = this.ui.tooltip.outerWidth();
      this.ui.tooltip.css({
        left: Math.max(0, Math.min(chartWidth - ttWidth, left - ttWidth / 2)),
        display: 'block'
      });
    },

    onChartLeave: function () {
      this.$('.js-bar').removeClass('hover');
      this.ui.tooltip.hide();
    },

    // ---------- formatting -----------------------------------------------

    formatNumber: function (n) {
      return String(n || 0).replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
    },

    formatBytes: function (n) {
      if (n < 1024) { return n + ' B'; }
      var units = ['KB', 'MB', 'GB', 'TB'];
      var i = -1;
      do { n = n / 1024; i++; } while (n >= 1024 && i < units.length - 1);
      return n.toFixed(n < 10 ? 1 : 0) + ' ' + units[i];
    },

    formatMs: function (ms) {
      if (!ms) { return '0 ms'; }
      if (ms < 1000) { return ms + ' ms'; }
      return (ms / 1000).toFixed(ms < 10000 ? 2 : 1) + ' s';
    }
  });
});

